import React, { createContext, useContext } from 'react';
import type {
  ATFilterAdvancedCtxType,
  ATFilterItemsType,
  ATContextProviderProps,
} from './types';

const ATFilterAdvancedContext = createContext<ATFilterAdvancedCtxType<any>>({
  filtersAdvanced: {},
  setFiltersAdvanced: () => null,
});

export const useATFilterAdvanced = (): ATFilterAdvancedCtxType<any> => {
  const ctx = useContext(ATFilterAdvancedContext);
  if (ctx === null) {
    throw new Error(
      'useATFilterAdvanced must be used within a ATFilterAdvancedProvider',
    );
  }
  return ctx;
};

export const ATFilterAdvancedContextProvider = <T extends Record<string, any>>({
  children,
}: ATContextProviderProps) => {
  const [filtersAdvanced, setFiltersAdvanced] = React.useState<
    ATFilterItemsType<T>
  >({});

  const value = React.useMemo(
    () => ({
      filtersAdvanced,
      setFiltersAdvanced,
    }),
    [filtersAdvanced],
  );

  return (
    <ATFilterAdvancedContext.Provider value={value}>
      {children}
    </ATFilterAdvancedContext.Provider>
  );
};
